<div id="buy-cd">
    <p>Wil je een CD kopen? Stuur ons een mailtje.
        <br>
        <a href="mailto:info@hotclubdefrank.nl">info@hotclubdefrank.nl</a></p>
</div>
<div class="cd-gallery">
     {#each data as obj, index}
     <div class="gallery-item">
         <div class="image-container">
             <img
                 src="assets/albums/{obj.image}"
                 class="gallery-image"
                 id="gallery-image-{index}"
                 alt="{obj.title}"
                on:click={openModal}>
         </div>
         <div class="text-container">
             <p class="title">{obj.title}</p>
             <p class="info">({obj.year}{#if obj.label}, {obj.label}{/if})</p>
             <ol class="songlist">
                 {#each obj.songs as song}
                     <li>{song}</li>
                 {/each}
             </ol>
         </div>
     </div>
     {:else}
        <p>No images found!</p>
     {/each}
</div>

{#if modalSrc}
    <Modal src={modalSrc} on:close="{() => modalSrc=''}">
    </Modal>
{/if}

<script>
 import Modal from '../Components/Modal.svelte';
 let modalSrc = "";

 function openModal(event) {
     modalSrc = event.target.src;
 }

 export let data = [];
 const content = document.getElementById("content");

 var xmlhttp = new XMLHttpRequest();
 xmlhttp.onreadystatechange = function() {
     if (this.readyState == 4 && this.status == 200) {
         data = JSON.parse(this.responseText).reverse();
     }
 };
 xmlhttp.open("GET", "cds.json", true);
 xmlhttp.send();
</script>

<style>
 #cd-content {
     text-align: center;
 }

 #buy-cd {
     text-align: center;
 }

 p {
     font-size: 1.5em;
     display: block;
 }

 img.gallery-image {
     cursor: zoom-in;
     position: absolute;
     width: 100%;
     height: 100%;
     object-fit: cover;
 }

 .image-container {
     width: 100%;
     object-fit: cover;
     padding-bottom: 100%;
     position: relative;
 }


 a {
     color: var(--highlight-color);
     font-weight: bold;
 }

 .cd-gallery {
     grid-auto-rows: auto;
     width: 100%;
 }

 .text-container {
     text-align: center;
 }

 .title {
     font-weight: bold;
     margin-bottom: 0.2em;
 }

 .info {
     color: #666666;
     font-size: 1.2em;
     margin-top: 0.2em;
 }

 .songlist {
     text-align: left;
 }

 li {
     padding-bottom: 6px;
 }
</style>
